module.exports = __webpack_public_path__ + "img/arrow-left.e8b0102.svg";